export function toSnakeCase(str) {
    return str
        .toLowerCase()
        .replace(/\s+/g, '_');
}